import { useLanguage } from '../contexts/LanguageContext';

/**
 * Language toggle component for switching between English and Portuguese.
 * Displays flag emojis and current language code.
 */
interface LanguageToggleProps {
    variant?: 'white' | 'primary';
    className?: string;
}

export function LanguageToggle({ variant = 'white', className = '' }: LanguageToggleProps) {
    const { language, toggleLanguage } = useLanguage();

    const colorClass = variant === 'primary' ? 'text-primary-default' : 'text-pure-0';
    const bgStyle = variant === 'primary'
        ? { backgroundColor: 'transparent', border: '1px solid currentColor' }
        : { backgroundColor: 'rgba(255,255,255,0.15)', border: 'none' };

    return (
        <button
            onClick={toggleLanguage}
            className={`d-flex align-items-center px-2 py-1 rounded transition-colors text-sm font-medium cursor-pointer ${colorClass} ${className}`}
            style={{ ...bgStyle }}
            title={language === 'en' ? 'Switch to Portuguese' : 'Mudar para Inglês'}
            aria-label={language === 'en' ? 'Switch to Portuguese' : 'Mudar para Inglês'}
        >
            {language === 'en' ? 'EN' : 'PT'}
        </button>
    );
}
